import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// primeReact
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { Accordion, AccordionTab } from "primereact/accordion";
// context
import { useContextSimulator } from "../../SimulatorContext";
import { useAppContext } from "../../../../../../context/AppContext";

import Map from "../../../Map/Map";
import { useQuery } from "react-query";
import { getMapImage } from "../../../../../../services/GlobalRoles/getMapImage";
import { Skeleton } from "primereact/skeleton";
import EnterpriseMap from "../../../Map/Map";
import { Button } from "primereact/button";
import AccordionSale from "../AccordionSale";
import { ToggleButton } from "primereact/togglebutton";

const ModalConfig = ({ activeAccordion, empId }) => {
  const {
    simulatorData,
    selectedPricingTable,
    setSelectedPricingTable,
    pricingTables,
    loadingLands,
    blocks,
    currentBlock,
    setCurrentBlock,
    lands,
    currentLand,
    setCurrentLand,
    fetchLandsSelect,
    setTestId,
    setSkeleton,
    discount,
    setDiscount,
    landValue,
    setLandValue,
    toggle,
    chooseEntry, setChooseEntry
  } = useContextSimulator();

  const { id } = useParams(); // state.empId from enterprise

  const refId = id !== undefined ? id : empId;

  const [loadingBlocks, setLoadingBlocks] = useState(true);
  // const [loadingLands, setLoadingLands] = useState(true);
  const [hideSelects, setHideSelects] = useState(false);
  const [message, setMessage] = useState("");

  const { nomenclatures, permissions } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);

  const { data: hasMap } = useQuery({
    queryKey: [`map-image-${refId}`],
    queryFn: () => getMapImage(refId),
    retry: false,
    enabled: !!permissions?.includes("20")
  });

  useEffect(() => {
    if (!blocks && empId !== 0) {
      setMessage(
        `Cadastre ${nomenclature[0].value} e ${nomenclature[1].value}`
      );
      setHideSelects(true);
      return;
    }
    setLoadingBlocks(false);
  }, [blocks]);

  // useEffect(() => {
  //   if (lands) {
  //     setLoadingLands(false);
  //   }
  // }, [lands]);

  useEffect(() => {
    if (simulatorData) {
      if (
        discount !== 0 &&
        parseFloat(discount) < parseFloat(simulatorData.land_value)
      ) {
        setLandValue(
          parseFloat(simulatorData.land_value).toFixed(2) -
          parseFloat(discount).toFixed(2)
        );
      } else {
        setLandValue(parseFloat(simulatorData.land_value).toFixed(2))
      }
    }
  }, [discount]);

  return (
    <>
      <Accordion activeIndex={activeAccordion}>
        <AccordionTab
          header={
            <div className="flex align-items-center">
              <i className="fa fa-file-invoice-dollar me-2"></i>
              <span className="vertical-align-middle">
                Configurações Gerais
              </span>
            </div>
          }
        >
          <div className="row">
            {/* {console.log(simulatorData)}
          {console.log(landValue)}
          {console.log(typeof landValue)}
          {console.log(parseFloat((parseFloat(simulatorData.land_value) / 100) * simulatorData.max_term_discount))}
          {console.log(discount)} */}
            {console.log("Discount in Modal Config: ", discount)}
            {simulatorData && simulatorData.enable_term_discount && !toggle && (
              <div className="col-md-4 py-2">
                <label className="mb-3">Desconto</label>
                <InputNumber
                  value={discount}
                  onValueChange={(e) => {
                    setDiscount(e.value);
                    console.log("Discount: ", e.value);
                  }}
                  mode="currency"
                  currency="BRL"
                  locale="pt-BR"
                  useGrouping={true}
                  className="w-100"
                  min={0}
                  max={parseFloat((parseFloat(simulatorData.land_value) / 100) * simulatorData.max_term_discount)}
                />
              </div>
            )}
            <div className="col-md-4 py-2">
              <label className="mb-3">Escolher entrada</label>
              <ToggleButton
                checked={chooseEntry}
                onChange={() => setChooseEntry(!chooseEntry)}
                onLabel={"Sim"}
                offLabel={"Não"}
                onIcon="pi pi-check"
                offIcon="pi pi-times"
                className={`w-100 me-3`}
                tooltip="Clique para ativar a configuração de 'desejo escolher entrada'."
                tooltipOptions={{ position: "top" }}
              />
            </div>
            <div className="col-md-8 py-2">
              <label className="mb-3">Tabela de Amortização Financiamento</label>
              <Dropdown
                value={selectedPricingTable}
                onChange={(e) => setSelectedPricingTable(e.value)}
                options={pricingTables}
                optionLabel="label"
                placeholder="Selecione"
                className="bg-none px-0 w-100"
              />
            </div>
          </div>
        </AccordionTab>
        {empId !== 0 && (
          <>
            <AccordionTab
              disabled={!simulatorData}
              header={
                <div className="flex align-items-center">
                  <i className="pi pi-user me-2"></i>
                  <span className="vertical-align-middle">Equipe de Venda</span>
                </div>
              }
            >
              <AccordionSale />
            </AccordionTab>
            <AccordionTab
              header={
                <div className="flex align-items-center">
                  <i className="fa-solid fa-cubes me-2"></i>
                  <span className="vertical-align-middle">Unidade</span>
                </div>
              }
            >
              <div className="row">
                <div className="col-md-12 pb-2">
                  <div className="card mb-3 p-3 bg-warning-300 rounded-3 bg-opacity-75">
                    <span className="text-center">
                      <i className="bi bi-info-circle-fill me-1"></i>
                      <b>Atenção</b>
                      <br />
                      Selecione uma unidade para realizar uma simulação.
                    </span>
                  </div>
                  {!hasMap?.file && !blocks && !loadingBlocks && message && (
                    <div className="card mb-3 p-3 bg-red-300 rounded-3 bg-opacity-75">
                      <span className="text-center">
                        <i className="bi bi-info-circle-fill me-1"></i>
                        <b>Atenção</b>
                        <br />
                        {message}
                      </span>
                    </div>
                  )}

                  {loadingBlocks && (
                    <>
                      <div className="row d-flex mb-3">
                        <div className="col-md-6 col-sm-12">
                          <label className="mb-3">{nomenclature[0].value}</label>
                          <Skeleton width="100%" height="40px"></Skeleton>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <label className="mb-3">{nomenclature[1].value}</label>

                          <Skeleton width="100%" height="40px"></Skeleton>
                        </div>
                      </div>
                    </>
                  )}

                  {blocks && (
                    <div className="row mb-3">
                      <div className="col-md-6 col-sm-12">
                        <label className="mb-3">{nomenclature[0].value}</label>
                        <Dropdown
                          filter
                          showClear
                          value={currentBlock}
                          onChange={(e) => {
                            setCurrentBlock(e.value);
                            fetchLandsSelect(e.value);
                          }}
                          options={blocks}
                          disabled={loadingBlocks}
                          placeholder={
                            loadingBlocks ? "Carregando..." : "Selecione"
                          }
                          optionLabel="label"
                          className="bg-none px-0 w-100"
                        />
                      </div>

                      <div className="col-md-6 col-sm-12">
                        <label className="mb-3">{nomenclature[1].value}</label>
                        <Dropdown
                          filter
                          showClear
                          value={currentLand}
                          onChange={(e) => {
                            setCurrentLand(e.value);
                            setTestId(e.value);
                            setSkeleton(true);
                          }}
                          options={lands}
                          optionLabel="label"
                          disabled={loadingLands}
                          placeholder={
                            currentBlock && loadingLands
                              ? "Carregando..."
                              : "Selecione"
                          }
                          className="bg-none px-0 w-100"
                        />
                      </div>
                    </div>
                  )}

                  {hasMap?.file && (
                    <div style={{ overflowX: "scroll" }}>
                      <EnterpriseMap
                        empId={empId}
                        customAction={"simulator"}
                      />
                    </div>
                  )}
                </div>
              </div>
            </AccordionTab>
          </>
        )}
      </Accordion>
    </>
  );
};

export default ModalConfig;
